import React, { memo, useCallback } from "react";
import { useGlobalContext } from "../../../../globalContext";
import { Button, IconButton } from "../../../../components/lib/Button";
import { ButtonGroupRight } from "../../../../components/lib/ButtonGroup";
import { UniqueUser, useUploadUserContext } from "../context/UploadUserContext";

type DeleteUserProps = {
  user: UniqueUser;
  userList: UniqueUser[];
  keyType: string;
};

const DeleteUser = memo(({ user, userList, keyType }: DeleteUserProps) => {
  const { showConfirmationModal, closeConfirmationModal } = useGlobalContext();
  const { updateList } = useUploadUserContext();

  const handleDelete = useCallback(
    async (user) => {
      const newList = userList.filter((item) => item._uniqueId !== user._uniqueId);
      updateList(newList, keyType);
      closeConfirmationModal();
    },
    [updateList, userList, closeConfirmationModal, keyType]
  );

  const deleteConfirmation = useCallback(
    async (user) => {
      const header = "Confirm Delete User";
      const message = <span>Do you really want to delete {user?.username}</span>;
      const footer = (
        <ButtonGroupRight fill css={{ flexDirection: "row-reverse" }}>
          <Button
            size="large"
            title="Cancel changes and close editor"
            onClick={closeConfirmationModal}
          >
            Cancel
          </Button>
          <Button
            color="danger"
            size="large"
            icon={["far", "trash-alt"]}
            loadingText="Deleting..."
            onClick={() => handleDelete(user)}
          >
            Yes, Delete {user.username}
          </Button>
        </ButtonGroupRight>
      );

      showConfirmationModal(message, header, footer);
    },
    [handleDelete, showConfirmationModal, closeConfirmationModal]
  );

  return (
    <IconButton
      css={{ width: "28px" }}
      icon="trash"
      size="small"
      color="danger"
      variant="text"
      title="Delete item"
      onClick={() => deleteConfirmation(user)}
    />
  );
});

export default DeleteUser;
